module.exports = __webpack_public_path__ + "img/primary-left-arrow.0570a827.svg";